import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-ordered-list-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        d="M11.333 15.6667H17.9997M11.333 12H17.9997M11.333 8.33333H17.9997M6.33301 14.3033V14.1873C6.33301 13.6693 6.78101 13.25 7.33301 13.25H7.35967C7.89767 13.25 8.33301 13.6587 8.33301 14.162C8.33301 14.382 8.25701 14.5953 8.11701 14.77L6.33301 17H8.33301M6.33301 7.62467L7.66634 7V10.75" />
    </svg>
  `,
})
export class OrderedListIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
